import { useState } from 'react';
import { useRefresh } from 'react-admin';
import { useRunRequest } from '@/hooks';
import { TurnActionsEnum, TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { ConnectReportProps } from '../types';
import { UpdateOrderIdForm, UseControllerReturn } from './types';

const useController = ({ onClose, record, worker }: ConnectReportProps): UseControllerReturn => {
  const refresh = useRefresh();
  const { runRequest } = useRunRequest();
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const handleOpenModal = () => setShowUpdateModal(true);
  const handleCloseModal = () => setShowUpdateModal(false);

  const handleUpdateOrderId = async ({ connectOrderId, reason }: UpdateOrderIdForm) => {
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: worker?.id,
        target: TurnTargetsEnum.OneOffChecks,
        targetId: record?.id,
        action: TurnActionsEnum.UpdateConnectOrderReport,
        data: {
          connect_order_id: connectOrderId,
          reason: reason || undefined,
        },
      },
      mode: 'notify',
      notify: {
        onSuccess: {
          message: 'Connect Order ID updated successfully',
          postAction: () => {
            handleCloseModal();
            refresh();
            onClose();
          },
        },
      },
    });
  };

  return {
    connectOrderReport: record?.connect_order_report,
    handleCloseModal,
    handleOpenModal,
    handleUpdateOrderId,
    showUpdateModal,
  };
};

export default useController;
